const template = (extraClass) => `
<div class="loading ${extraClass}">
    <div class="loading__spinner"></div>
</div>
`
export default template
